import { useLayoutEffect, useState } from 'react';

const defaultOptions = {
  root: undefined,
  rootMargin: '0px',
  threshold: 0,
};

const useViewportSpy = (elementRef, options = defaultOptions) => {
  const [isVisible, setIsVisible] = useState(false);

  useLayoutEffect(() => {
    try {
      const observer = new IntersectionObserver(
        (entries) =>
          entries.forEach((item) => {
            const nextValue = item.isIntersecting;
            setIsVisible(nextValue);
          }),
        options
      );

      observer.observe(elementRef.current);

      return () => {
        observer.disconnect();
      };
    } catch (error) {
      console.error('IntersectionObserver is not supported', error);
      return () => {};
    }
  }, [options, elementRef]);

  return isVisible;
};

export default useViewportSpy;
